import bigcommerceGenericDefaults from '../bigcommerce-generic/config.js';

export default {
  includes: ['bigcommerce-generic'],
  ...bigcommerceGenericDefaults,
  fitmentSearch: {
    ...bigcommerceGenericDefaults.fitmentSearch,
  },
  SearchRequestDefaults: {
    pageSize: 24,
  },
  Widgets: [
    ...bigcommerceGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'HomeVehicleWidget_tab',
          'SearchBox',
          'Garage',
          'VerifyFitment',
          'FitmentTable',
          'CategoryPage',
        ].includes(w.name),
    ),
    {
      name: 'HomeVehicleWidget_tab',
      type: 'VehicleWidget',
      location: {
        lastChildOf: '[data-content-region="home_below_carousel"]',
        class: 'container',
      },
      template: 'fitmentSearch/collapsibleVehicleWidget',
      columnBreakpoint: 650,
    },
    {
      name: 'SearchBox',
      location: {
        replace: 'form[data-quick-search-form]',
        class: 'search search-modal__form',
      },
      template: 'SearchBox',
    },
    {
      name: 'Garage',
      location: {
        insertBefore: '.navUser-item--cart',
        wrapper: 'li',
        class: 'navUser-item cm_garage_container',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'CategoryFacetPanel',
      type: 'SearchPage',
      location: {
        replace: '#faceted-search-container',
        class: 'cm_FacetPanel__category',
      },
      template: 'FacetPanelContainer',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: { replace: '#product-listing-container', class: 'cm_main-content' },
      template: 'MainContent',
    },
    {
      name: 'VerifyFitment',
      location: {
        insertBefore: 'body.page-type__product .productView-options #add-to-cart-wrapper',
      },
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'FitmentTable',
      location: {
        lastChildOf: '.tabs-contents',
        class: 'tab-content',
        id: 'tab-fitment',
      },
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'FitmentTableTab',
      type: 'FitmentTable',
      location: { lastChildOf: '.productView-description ul', wrapper: 'li', class: 'tab' },
      template: 'fitmentSearch/fitmentTableTab',
    },
  ],
};
